import { RestResponseData } from '../../api/Rest';
import { getGameOpponents, getGameRecords } from '../../api/Rest/space';
import { ToAttachmentWithPath } from '../../api/utils';
// import { WebSocketTopicPushListener } from '../../api/WebSocket';
// import { WebSocketTopicType } from '../../api/WebSocket/push';
import { UserId, Uuid } from '../../models/Base';
import Repository, { Cursor, RepositoryJson } from '../../models/Repository';
import { AsyncActionOptions, FetchActionResult } from '../../models/Store';
import {
  ModifiedPick,
  RequireAtLeastOne,
  RequiredPick,
  SecondParameter,
} from '../../models/Utils';
import { SpaceSummary, SpaceSummaryJson } from '../SpaceStore';
import { AlbumSummary, AlbumSummaryJson } from './AlbumSummary';
import { ChallengeRecord, ChallengeRecordJson } from './ChallengeRecord';
import { GameRecord, GameRecordJson } from './GameRecord';

export enum GameRecordListType {
  Rating = 'Rating',
}

export type GameRecordMapField = string;
export type GameRecordListField = string | GameRecordListType;
export class GameRecordRepository extends Repository<
  GameRecord,
  GameRecordJson<Date | number>,
  GameRecordMapField,
  GameRecordListField
> {
  constructor(
    repository?: RepositoryJson<
      GameRecordJson<Date | number>,
      GameRecordMapField,
      GameRecordListField,
      Date | number
    >,
  ) {
    super({ ...repository }, (x) => new GameRecord(x));
  }
}

export type ChallengeRecordMapField = string;
export type ChallengeRecordListField = string;
export class ChallengeRecordRepository extends Repository<
  ChallengeRecord,
  ChallengeRecordJson<Date | number>,
  ChallengeRecordMapField,
  ChallengeRecordListField
> {
  constructor(
    repository?: RepositoryJson<
      ChallengeRecordJson<Date | number>,
      ChallengeRecordMapField,
      ChallengeRecordListField,
      Date | number
    >,
  ) {
    super({ ...repository }, (x) => new ChallengeRecord(x));
  }
}

// AlbumSummaryRepository
export type AlbumSummaryMapField = string;
export type AlbumSummaryListField = string;
export class AlbumSummaryRepository extends Repository<
  AlbumSummary,
  AlbumSummaryJson<Date | number>,
  AlbumSummaryMapField,
  AlbumSummaryListField
> {
  constructor(
    repository?: RepositoryJson<
      AlbumSummaryJson<Date | number>,
      AlbumSummaryMapField,
      AlbumSummaryListField,
      Date | number
    >,
  ) {
    super({ ...repository }, (x) => new AlbumSummary(x));
  }
}

// SpaceSummaryRepository
export type SpaceSummaryMapField = string;
export type SpaceSummaryListField = string;
export class SpaceSummaryRepository extends Repository<
  SpaceSummary,
  SpaceSummaryJson<Date | number>,
  SpaceSummaryMapField,
  SpaceSummaryListField
> {
  constructor(
    repository?: RepositoryJson<
      SpaceSummaryJson<Date | number>,
      SpaceSummaryMapField,
      SpaceSummaryListField,
      Date | number
    >,
  ) {
    super({ ...repository }, (x) => new SpaceSummary(x));
  }
}

export type PlayingRecord = RequireAtLeastOne<{
  gameRecord: ToAttachmentWithPath<GameRecordJson>;
  // slideshowRecord: SlideshowRecordJson;
  // challengeRecord: ChallengeRecordJson & { classroomId: Uuid };
}>;

export interface RecordStoreStateJson {
  // playingRecord: PlayingRecord | undefined;
  gameRecords: RepositoryJson<
    GameRecordJson,
    GameRecordMapField,
    GameRecordListField,
    number
  >;
  challengeRecords: RepositoryJson<
    ChallengeRecordJson,
    ChallengeRecordMapField,
    ChallengeRecordListField,
    number
  >;
  albumSummaries: RepositoryJson<
    AlbumSummaryJson,
    AlbumSummaryMapField,
    AlbumSummaryListField,
    number
  >;
  spaceSummaries: RepositoryJson<
    SpaceSummaryJson,
    SpaceSummaryMapField,
    SpaceSummaryListField,
    number
  >;
}

export type RecordStoreState = {
  playingRecord: PlayingRecord | undefined;
  gameRecords: GameRecordRepository;
  challengeRecords: ChallengeRecordRepository;
  albumSummaries: AlbumSummaryRepository;
  spaceSummaries: SpaceSummaryRepository;
};

export interface RecordStoreAction {
  savePlayingRecord: (playingRecord: PlayingRecord) => void;
  syncPlayingRecord: () => Promise<void>;
  clearPlayingRecord: () => void;
  // // game record
  // addGameRecords: (
  //   classroomId: Uuid,
  //   gameSetId: Uuid | undefined,
  //   gameId: Uuid | undefined,
  //   ...gameRecords: GameRecord[]
  // ) => void;
  // setGameRecord: (gameRecord: GameRecord) => void;
  // setGameEvaluations: (...gameRecords: GameRecord[]) => void;
  getGameRecord: (gameRecordId: Uuid) => GameRecord | null | undefined;
  getGameRecords: (fieldName: string) => GameRecord[];
  // getGameRecordsBySpace: (spaceId: Uuid) => GameRecord[] | undefined;
  // getGameRecordsByAlbum: (gameSetId: Uuid) => GameRecord[] | undefined;
  // deleteGameRecords: (gameId: Uuid) => void;
  // fetchGameRecords: (
  //   classroomId: Uuid,
  //   playedBy: UserId,
  //   gameSetId?: Uuid,
  //   gameId?: Uuid,
  //   forceFetch?: boolean,
  // ) => Promise<void>;
  fetchGameRecords: (
    params: {
      fieldName: string;
      classroomId: Uuid;
      playedBy: UserId;
      gameSetId: Uuid;
      gameId?: Uuid;
    },
    cursor: Cursor,
    options?: AsyncActionOptions,
  ) => Promise<FetchActionResult>;
  // fetchGameRecordsForEvaluation: (
  //   classroomId: Uuid,
  //   params: ModifiedPick<
  //     NonNullable<SecondParameter<typeof getGameRecords>>,
  //     'evaluated',
  //     'cursor' | 'limit'
  //   >,
  //   options?: AsyncActionOptions,
  // ) => Promise<FetchActionResult>;
  syncGameRecord: (
    gameRecord: ToAttachmentWithPath<GameRecordJson>,
    isAsync: boolean,
  ) => Promise<void>;
  // syncGameEvaluation: (
  //   gameRecord: RequiredPick<
  //     ToAttachmentWithPath<GameRecordJson>,
  //     | 'classroomId'
  //     | 'gameRecordId'
  //     | 'reward'
  //     | 'score'
  //     | 'stars'
  //     | 'defeatedOpponents'
  //     | 'evaluation'
  //   >,
  // ) => Promise<void>;
  // opponents
  // fetchGameOpponents: (
  //   classroomId: Uuid,
  //   gameSetId: Uuid,
  //   gameId: Uuid,
  //   limit?: number,
  // ) => Promise<
  //   RestResponseData<
  //     typeof getGameOpponents<{
  //       gameSetId: Uuid;
  //       gameId: Uuid;
  //       withProfiles: true;
  //     }>
  //   >
  // >;
  getChallengeRecord: (
    challengeRecordId: Uuid,
  ) => ChallengeRecord | null | undefined;
  getChallengeRecords: (fieldName: Uuid) => ChallengeRecord[];
  fetchChallengeRecords: (
    params: {
      fieldName: string;
      classroomId: Uuid;
      gameSetId: Uuid;
    },
    cursor: Cursor,
    options?: AsyncActionOptions,
  ) => Promise<FetchActionResult>;

  getAlbumSummary: (gameSetId: Uuid) => AlbumSummary | null | undefined;
  fetchAlbumSummaries: (
    params: { gameSetIds: Uuid[] },
    options?: AsyncActionOptions,
  ) => Promise<void>;
  updateAlbumSummary: (classroomId: Uuid, gameSetId: Uuid) => Promise<void>;
  moveInAlbumSummaryPath: (
    classroomId: Uuid,
    gameSetId: Uuid,
    moveTo: number,
  ) => Promise<void>;

  getSpaceSummary: (classroomId: Uuid) => SpaceSummary | null | undefined;
  fetchSpaceSummaries: (
    params: { classroomIds: Uuid[] },
    options?: AsyncActionOptions,
  ) => Promise<void>;
  updateSpaceSummary: (classroomId: Uuid) => Promise<void>;
  // opponents
  fetchGameOpponents: (
    classroomId: Uuid,
    gameSetId: Uuid,
    gameId: Uuid,
    limit?: number,
  ) => Promise<
    RestResponseData<
      typeof getGameOpponents<{
        gameSetId: Uuid;
        gameId: Uuid;
        withProfiles: true;
      }>
    >
  >;
  // websocker listener
  // onUserTopicPush: WebSocketTopicPushListener<WebSocketTopicType.User>;
  // prune listeners
  onGameRecordPrune: (record: GameRecord) => void;
}
